<script setup lang="ts">
  export interface CardHeaderProps {
    /**
     * Title to be displayed
     */
    title: string;
    /**
     * Subtitle to be displayed
     */
    subtitle?: string;
    /**
     * Additional text to be displayed
     */
    text?: string;
  }

  const props = defineProps<CardHeaderProps>();
</script>

<template>
  <header class="stash-card-header px-6 font-medium text-ice-900" data-test="stash-card-header">
    <h4 class="text-base">
      {{ props.title }}
    </h4>
    <p v-if="props.subtitle" class="mb-0 mt-1.5">
      {{ props.subtitle }}
    </p>
    <span v-if="props.text" class="mt-1.5 text-ice-700">
      {{ props.text }}
    </span>
  </header>
</template>
